"use strict";
/** @jsx jsx */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const react_router_dom_1 = require("react-router-dom");
const styled_react_1 = require("./styled-react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Link = (props) => {
    const { color, hoverColor, disabled, children } = props, rest = __rest(props, ["color", "hoverColor", "disabled", "children"]);
    return ((0, core_1.jsx)(react_router_dom_1.Link, Object.assign({ css: (0, styled_react_1.dynamicLinkStyle)(color, hoverColor, disabled) }, rest), children));
};
Link.defaultProps = {
    children: undefined,
    color: styles_scss_1.default.primary,
    hoverColor: styles_scss_1.default.primaryHover,
    disabled: false,
};
exports.default = Link;
